"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _amsRequests = _interopRequireDefault(require("../wrappers/ams-requests"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PendingHeader = function PendingHeader() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3 font-bold"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 border-b-2"
  }, "Pending Requests"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border-b-2 text-center"
  }, "Age"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-5 border-b-2 text-center"
  }, "Accept Request"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border-b-2 text-center"
  }, "Reject Request"));
};

var PendingRequest = function PendingRequest(_ref) {
  var request = _ref.request,
      groups = _ref.groups,
      signupAccept = _ref.signupAccept,
      signupReject = _ref.signupReject,
      props = _objectWithoutProperties(_ref, ["request", "groups", "signupAccept", "signupReject"]);

  var age = ((Date.now() - new Date(request.created_at).valueOf()) / (1000 * 60 * 60)).toFixed(1);

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      group = _React$useState2[0],
      setGroup = _React$useState2[1],
      canAccept = group && request.state === "pending";

  var handleSubmit = _react["default"].useCallback(function (e) {
    e.preventDefault();
    signupAccept(request.user_email, group.name);
    setGroup(null);
  }, [signupAccept, request, group]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3 my-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3"
  }, request.user_email), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 text-center"
  }, age, " hrs"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-5"
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-5 gap-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    multi: false,
    domain: groups,
    accessor: function accessor(g) {
      return g.name;
    },
    value: group,
    onChange: setGroup,
    placeholder: "Select a group..."
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    type: "submit",
    block: true,
    disabled: !canAccept
  }, "accept"))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 text-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonDanger",
    showConfirm: true,
    onClick: function onClick(e) {
      return signupReject(request);
    }
  }, "reject")));
};

var PendingRequests = function PendingRequests(_ref2) {
  var requests = _ref2.requests,
      props = _objectWithoutProperties(_ref2, ["requests"]);

  return !requests.length ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-1"
  }, /*#__PURE__*/_react["default"].createElement(PendingHeader, null), requests.map(function (req) {
    return /*#__PURE__*/_react["default"].createElement(PendingRequest, _extends({
      key: req.user_email,
      request: req
    }, props));
  }));
};

var AwaitingHeader = function AwaitingHeader() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3 font-bold"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 border-b-2"
  }, "Awaiting Requests"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border-b-2 text-center"
  }, "Age"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border-b-2 text-center"
  }, "Reject Request"));
};

var AwaitingRequest = function AwaitingRequest(_ref3) {
  var request = _ref3.request,
      signupReject = _ref3.signupReject,
      props = _objectWithoutProperties(_ref3, ["request", "signupReject"]);

  var age = ((Date.now() - new Date(request.created_at).valueOf()) / (1000 * 60 * 60)).toFixed(1);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3 my-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3"
  }, request.user_email), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 text-center"
  }, age, " hrs"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 text-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonDanger",
    showConfirm: true,
    onClick: function onClick(e) {
      return signupReject(request);
    }
  }, "reject")));
};

var AwaitingRequests = function AwaitingRequests(_ref4) {
  var requests = _ref4.requests,
      props = _objectWithoutProperties(_ref4, ["requests"]);

  return !requests.length ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-1"
  }, /*#__PURE__*/_react["default"].createElement(AwaitingHeader, null), requests.map(function (req) {
    return /*#__PURE__*/_react["default"].createElement(AwaitingRequest, _extends({
      key: req.user_email,
      request: req
    }, props));
  }));
};

var RejectedHeader = function RejectedHeader() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3 font-bold"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 border-b-2"
  }, "Rejected Requests"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-5 border-b-2 text-center"
  }, "Accept Request"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border-b-2 text-center"
  }, "Delete Request"));
};

var RejectedRequest = function RejectedRequest(_ref5) {
  var request = _ref5.request,
      groups = _ref5.groups,
      signupAccept = _ref5.signupAccept,
      deleteRequest = _ref5.deleteRequest,
      props = _objectWithoutProperties(_ref5, ["request", "groups", "signupAccept", "deleteRequest"]);

  var _React$useState3 = _react["default"].useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      group = _React$useState4[0],
      setGroup = _React$useState4[1],
      canAccept = group && request.state === "rejected";

  var handleSubmit = _react["default"].useCallback(function (e) {
    e.preventDefault();
    signupAccept(request.user_email, group.name);
    setGroup(null);
  }, [signupAccept, request, group]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3 my-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3"
  }, request.user_email), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-5"
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-5 gap-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    multi: false,
    domain: groups,
    accessor: function accessor(g) {
      return g.name;
    },
    value: group,
    onChange: setGroup,
    placeholder: "Select a group..."
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    type: "submit",
    block: true,
    disabled: !canAccept
  }, "accept"))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 text-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonDanger",
    showConfirm: true,
    onClick: function onClick(e) {
      return deleteRequest(request);
    }
  }, "delete")));
};

var RejectedRequests = function RejectedRequests(_ref6) {
  var requests = _ref6.requests,
      props = _objectWithoutProperties(_ref6, ["requests"]);

  return !requests.length ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-1"
  }, /*#__PURE__*/_react["default"].createElement(RejectedHeader, null), requests.map(function (req) {
    return /*#__PURE__*/_react["default"].createElement(RejectedRequest, _extends({
      key: req.user_email,
      request: req
    }, props));
  }));
};

var _default = (0, _amsRequests["default"])(function (_ref7) {
  var pending = _ref7.pending,
      awaiting = _ref7.awaiting,
      rejected = _ref7.rejected,
      props = _objectWithoutProperties(_ref7, ["pending", "awaiting", "rejected"]);

  var _React$useState5 = _react["default"].useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      open = _React$useState6[0],
      setOpen = _React$useState6[1],
      stop = _react["default"].useCallback(function (e) {
    return e.stopPropagation();
  }, []),
      theme = (0, _avlComponents.useTheme)();

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n        mb-5 py-2 px-4 border-2 rounded\n        ".concat(open ? theme.accent1 : "cursor-pointer", "\n      "),
    style: {
      borderColor: "currentColor"
    },
    onClick: function onClick(e) {
      stop(e);
      setOpen(true);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick(e) {
      stop(e);
      setOpen(!open);
    },
    className: "\n          border-b-2 cursor-pointer\n          ".concat(open ? "border-current" : "border-transparent", "\n        ")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa fa-".concat(open ? "minus" : "plus")
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold text-xl ml-2"
  }, "Requests")), !open ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PendingRequests, _extends({
    requests: pending
  }, props)), /*#__PURE__*/_react["default"].createElement(AwaitingRequests, _extends({
    requests: awaiting
  }, props)), /*#__PURE__*/_react["default"].createElement(RejectedRequests, _extends({
    requests: rejected
  }, props))));
});

exports["default"] = _default;